// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/admin/AdminPage.css
// module id = 2002
// module chunks = 0